// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__27g1-","x2":"styles_x2__3IQSv","left":"styles_left__6c_1w","down":"styles_down__1lvfG","light":"styles_light__2vvrV","primary":"styles_primary__2QnYT"};